module.exports = __webpack_public_path__ + "img/video-cover.ef798ccf.png";